import {animated, useSprings} from 'react-spring';

const threeDots = ['.', '.', '.'];

export const BreathableAnim = ({ text = threeDots }) => {
  const [springs, _api] = useSprings(text.length, (i) => ({
    from: {
      fontWeight: 300,
    },
    to: {
      fontWeight: 700,
    },
    loop: { reverse: true },
    delay: 100 * (i + 1),
    config: { duration: 1000 },
  }));
  return (
    <>
      {springs.map((style, i) => (
        <animated.span key={i} style={style}>
          {text[i]}
        </animated.span>
      ))}
    </>
  );
};

export default BreathableAnim;
